import { Injectable } from '@angular/core';
import { APP_CONSTANTS as CONST } from '@app/app.constants';

@Injectable({
  providedIn: 'root',
})
export class CameraPermissionService {
  async checkCameraPermission(): Promise<PermissionState> {
    try {
      const cameraPermissionStatus = await navigator.permissions.query({
        name: 'camera' as PermissionName,
      });
      return cameraPermissionStatus.state;
    } catch (err) {
      console.error('Error al verificar el estado del permiso:', err);
      return 'denied';
    }
  }

  async askForCameraPermission(): Promise<boolean> {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      stream.getTracks().forEach((track) => track.stop());
      return true;
    } catch (error) {
      console.log('Permiso denegado o error al acceder a la cámara: ', error);
      return false;
    }
  }
}
